// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAnalytics } from 'firebase/analytics'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyA6fOfbL5Y-Tbkch-ngPggS1-kbh8vX2eA',
  authDomain: 'player-67d5f.firebaseapp.com',
  projectId: 'player-67d5f',
  storageBucket: 'player-67d5f.appspot.com',
  messagingSenderId: '998434153306',
  appId: '1:998434153306:web:7668ad7ce050df2c7ec963',
  measurementId: 'G-6PDV445T1E',
  ignoreUndefinedProperties: true
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
const db = getFirestore(app)

export { db, analytics }
